import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appStrictNumbers]',
})
export class StrictNumbersDirective {
  private regEx: RegExp = new RegExp('^[0-9]*$');
  private specialKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];

  constructor(private elementRef: ElementRef) {}

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.includes(event.key)) return;

    const inputValue = this.elementRef.nativeElement.value.concat(event.key);
    if (inputValue && !String(inputValue).match(this.regEx)) {
      event.preventDefault();
    }
    return;
  }

  // Copy and Paste Action
  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text/plain') || '';

    if (clipboardData && this.regEx.test(clipboardData)) {
      const input = this.elementRef.nativeElement as HTMLInputElement;
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;
      const currentValue = input.value;

      const newValue =
        currentValue.substring(0, start) +
        clipboardData +
        currentValue.substring(end);

      // Update the input value if it's valid
      if (this.regEx.test(newValue)) {
        input.value = newValue;
        // Trigger input event to update the form control
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  }
}
